module.exports = __webpack_public_path__ + "img/apply-list-none.5345bf59.png";